{
  "general": {
    "title": "Porównaj opcje",
    "intro": "Szybkie spojrzenie na różnicę między Społecznością, Subskrypcją i Zakupem jednorazowym.",
    "tableheader": "Subskrypcja",
    "note1": "* Dostępne opcje zakupów grupowych i rabaty ilościowe.",
    "note2": "** Obsługiwane języki: Dansk, Deutsch, English, Español, Suomi, Français, Italiano, Norsk, Polski, Português (Brasil), Русский, Svenska",
    "note3": "*** Wymaga bezpłatnego konta społecznościowego myboardmaker.com i jest przeznaczone wyłącznie do przechowywania działań."
  },
  "columnHeadings": {
    "community": "SPOŁECZNOŚĆ",
    "onetime": "ZAKUP JEDNORAZOWY*",
    "personal": "SUBSKRYPCJA OSOBISTA",
    "professional": "SUBSKRYPCJA PROFESJONALISTY",
    "organization": "SUBSKRYPCJA INSTYTUCJONALNA"
  },
  "mobileHeadings": {
    "community": "Społeczność",
    "onetime": "Zakup jednorazowy*",
    "personal": "Subskrypcja osobista",
    "professional": "Subskrypcja profesjonalisty",
    "organization": "Subskrypcja instytucjonalna*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Aktywacje",
    "languages": "Języki**",
    "licensing": "Licencjonowanie",
    "pcsSymbols": "Symbole PCS",
    "templates": "Szablony",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Odtwórz aktywności jako instruktor",
    "playActivitiesStudent": "Odtwórz aktywności jako uczeń",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Zarządzanie instruktorami",
    "studentManagement": "Zarządzanie uczniami",
    "assignStudentActivities": "Przydzielaj aktywności uczniów",
    "cloudStorage": "Przechowywanie danych w chmurze",
    "createAndJoin": "Twórz grupy i dołączaj do nich",
    "accessCommunity": "Uzyskaj dostęp do ponad 120 tys. aktywności społeczności",
    "shareActivity": "Udostępniaj aktywności w społeczności",
    "curriculum": "Program nauczania i zawartość",
    "activitiesToGo": "Aktywności Boardmaker do wykonania",
    "instructionalSolutions": "Rozwiązania edukacyjne",
    "premiumActivities": "Aktywności Premium",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 urządzenia",
    "unlimited": "Bez ograniczeń",
    "byKey": "Klucz licencyjny",
    "symbols": "Ponad 80 000",
    "templates": "Ponad 600",
    "languages": "12",
    "login": "Zaloguj",
    "yes": "Tak",
    "yesNote": "Tak***",
    "no": "Nie"
  }
}